import {
  Banner,
  Breadcrumb,
  Container,
  Col,
  Footer,
  Paragraph,
  TextLink,
  Row,
  List,
  ListItem,
} from 'darrius';

import { HeadContent, Header } from '../../components';

import { type IGeolocPageProps } from '../../modules/geoloc/pageProps/@interfaces';

import styles from './GeolocTemplate.module.scss';
import Script from 'next/script';

function GeolocTemplate(props: IGeolocPageProps) {
  const {
    meta,
    breadcrumbs,
    slug,
    title,
    main,
    description,
    allCities,
    categoryTree,
    structuredData,
    footerContent,
    headerContent,
  } = props;

  const header = {
    signup: headerContent.signup,
    about: {
      text: headerContent.about.text,
      link: '/sobre-nos',
    },
  };

  return (
    <>
      <HeadContent
        metaTitle={meta.title}
        metaDescription={meta.description}
        canonicalLink={`https://www.getninjas.com.br/local/${slug}`}
        pageType="pages:geoloc"
      />

      <Container>
        <Header.Default header={header} />

        <Row className="space-between">
          <Col className="col-sm-12">
            <Breadcrumb className="hide-sm" breadcrumbs={breadcrumbs} />

            <Paragraph title={title} size="1" />

            <Paragraph title={main.title} text={main.text} size="2" />
          </Col>
        </Row>

        {categoryTree.length > 0 &&
          categoryTree.map((category) => (
            <Banner key={category.name}>
              <Paragraph size="3" title={category.name} />
              <List className={styles['geo-links']}>
                {category.items.map((item) => (
                  <ListItem key={item.name}>
                    <TextLink url={`/${item.slug}`} text={`${item.name}`} />
                  </ListItem>
                ))}
              </List>
            </Banner>
          ))}

        <Banner>
          <Paragraph
            size="3"
            title="Encontre Profissionais nas Principais Cidades"
          />
          <List className={styles['geo-links']}>
            {allCities.map((local) => (
              <ListItem key={local.slug}>
                <TextLink url={`/local/${local.slug}`} text={`${local.city}`} />
              </ListItem>
            ))}
          </List>
        </Banner>

        <Row className="space-top space-bottom">
          <Col className="col-sm-12">
            <Paragraph
              title={description.title}
              text={description.text}
              size="2"
            />
          </Col>
        </Row>
      </Container>

      <Footer data={footerContent} />

      <Script
        id="geo-loc-configs"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: structuredData,
        }}
      />
    </>
  );
}

export default GeolocTemplate;
